import axios from "axios";
import { baseUrl, timeout } from "./env";
import { getToken } from "./token";

axios.defaults.timeout = timeout;
axios.defaults.baseURL = baseUrl;

// 下载
export function download(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
        responseType: "blob",
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

export function postDownload(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, params, {
        responseType: "blob",
        headers: {
          'Content-Type': 'application/json;charset=UTF-8'
        }
      })
      .then((response) => {
        resolve(response);
      })
      .catch((err) => {
        reject(err);
      });
  });
}

//http request 拦截器
axios.interceptors.request.use(
  (config) => {
    config.data = JSON.stringify(config.data);
    config.headers = {
      ...(config.headers || {}),
      "oa-token": getToken(),
    };
    return config;
  },
  (error) => {
    return Promise.reject(err);
  }
);


// WEBPACK FOOTER //
// ./src/config/http.js